import { Facebook, Instagram } from "lucide-react";

export function HousesArt({ className, dark = "#14213D", light = "#FFFFFF" }) {
  return (
    <svg viewBox="0 0 160 140" className={className} aria-hidden="true">
      <circle cx="22" cy="104" r="16" fill={dark} opacity="0.55" />
      <rect x="19" y="112" width="6" height="22" rx="2" fill={dark} opacity="0.55" />
      <path d="M30 78 L84 34 L138 78 Z" fill={dark} />
      <rect x="42" y="72" width="84" height="62" rx="3" fill={dark} />
      <rect x="58" y="86" width="16" height="16" rx="1.5" fill={light} />
      <rect x="94" y="86" width="16" height="16" rx="1.5" fill={light} />
      <rect x="76" y="108" width="16" height="26" rx="1.5" fill={light} />
      <rect x="108" y="44" width="10" height="20" rx="1.5" fill={dark} />
      <path d="M118 96 L140 80 L160 96 Z" fill={dark} opacity="0.85" />
      <rect x="124" y="94" width="34" height="40" rx="2" fill={dark} opacity="0.85" />
      <rect x="131" y="104" width="8" height="8" rx="1" fill={light} />
      <rect x="143" y="104" width="8" height="8" rx="1" fill={light} />
      <rect x="137" y="118" width="8" height="16" rx="1" fill={light} />
    </svg>
  );
}

export function EnvelopeArt({ className }) {
  return (
    <svg viewBox="0 0 160 140" className={className} aria-hidden="true">
      <g transform="rotate(-14 80 80)">
        <rect x="20" y="42" width="120" height="78" rx="6" fill="#FFFFFF" />
        <path d="M20 48 L80 92 L140 48" fill="none" stroke="#C9D2DE" strokeWidth="3" strokeLinejoin="round" />
        <path d="M20 118 L66 82 M140 118 L94 82" fill="none" stroke="#DCE3EC" strokeWidth="2" />
        <rect x="108" y="50" width="22" height="18" rx="2" fill="#96C11F" />
        <rect x="111" y="53" width="16" height="12" rx="1" fill="none" stroke="#FFFFFF" strokeWidth="1.2" />
        <path d="M34 60 q6 -4 12 0 t12 0 t12 0" fill="none" stroke="#C9D2DE" strokeWidth="2" strokeLinecap="round" />
        <path d="M34 68 q6 -4 12 0 t12 0" fill="none" stroke="#C9D2DE" strokeWidth="2" strokeLinecap="round" />
      </g>
    </svg>
  );
}

export function LetterboxArt({ className }) {
  return (
    <svg viewBox="0 0 160 140" className={className} aria-hidden="true">
      <rect x="76" y="92" width="12" height="48" rx="2" fill="#14213D" />
      <path d="M30 60 a34 34 0 0 1 34 -34 h52 a34 34 0 0 1 34 34 v30 a4 4 0 0 1 -4 4 h-112 a4 4 0 0 1 -4 -4 Z" fill="#14213D" />
      <rect x="54" y="56" width="52" height="30" rx="4" fill="#96C11F" />
      <path d="M54 60 L80 76 L106 60" fill="none" stroke="#FFFFFF" strokeWidth="2.5" strokeLinejoin="round" />
      <path d="M150 42 l10 -8 M154 60 l12 -2 M146 28 l6 -11" stroke="#96C11F" strokeWidth="3" strokeLinecap="round" />
    </svg>
  );
}

export function PhoneArt({ className }) {
  return (
    <div className={className} aria-hidden="true">
      <div className="relative h-full w-full">
        <div className="absolute inset-y-0 right-0 w-[62%] rounded-[22px] border-[3px] border-white/85" />
        <div className="absolute right-[26%] top-2 h-1.5 w-[22%] rounded-full bg-white/70" />
        <span className="absolute right-[12%] top-[16%] grid h-11 w-11 place-items-center rounded-full bg-white text-[#2E6B3A] shadow-lg"><Instagram className="h-5 w-5" strokeWidth={2.4} /></span>
        <span className="absolute right-[36%] top-[44%] grid h-11 w-11 place-items-center rounded-full bg-white text-[#2E6B3A] shadow-lg"><Facebook className="h-5 w-5" strokeWidth={2.4} fill="#2E6B3A" /></span>
        <span className="absolute right-[6%] top-[62%] grid h-11 w-11 place-items-center rounded-full bg-[#C6EE5A] text-[#14213D] shadow-lg font-extrabold text-[18px] leading-none">X</span>
      </div>
    </div>
  );
}

export const INSIGHT_ART = { houses: HousesArt, envelope: EnvelopeArt, letterbox: LetterboxArt, phone: PhoneArt };
